/* eslint-disable */
// AUTO-GENERATED by scripts/generate-antd-compat-icons.mjs — do not edit by hand.
// Regenerate after changing icon-map.txt: `node scripts/generate-antd-compat-icons.mjs`
import { DeleteOutlined as AntdDeleteOutlined } from '@ant-design/icons'
import { Trash2 } from 'lucide-react'

import { createIconDispatcher } from '../dispatch'

export default /*#__PURE__*/ createIconDispatcher(
  'delete',
  AntdDeleteOutlined,
  Trash2
)
